import { ReducerHandlers } from 'lib/store/reducer';
import { State as ArticleInsertState } from '../../reducers';

export type State = {};

export const INITIAL_STATE: State = {};

export const reducerHandlers: ReducerHandlers<ArticleInsertState> = {};
